import { useState } from "react";
import { LockIcon } from "@/assets/icons";
import { Button, Input, Stack, Typography } from "@altimateai/lego";

interface RegenerateModalProps {
  handleRegenerate: () => void;
}

const RegenerateModal = ({ handleRegenerate }: RegenerateModalProps) => {
  const [textInput, setTextInput] = useState("");

  const handleTextInput = (e: React.ChangeEvent<HTMLInputElement>) => {
    setTextInput(e.target.value);
  };

  return (
    <div>
      <Stack direction="column" justify="center" align="center">
        <div className="al-bg-blue-100 al-rounded-full al-p-4">
          <LockIcon />
        </div>
        <Typography className="al-text-center">
          Are you sure you want to regenerate your Altimate API key? Please note that your current
          API key will be deactivated and <span>cannot be recovered </span>
          for security reasons.
        </Typography>
        <div className="al-mt-4">Type "regenerate" to confirm</div>
        <Input placeholder="regenerate" value={textInput} onChange={handleTextInput} />
        <Button variant="default" disabled={textInput !== "regenerate"} onClick={handleRegenerate}>
          Yes, regenerate
        </Button>
      </Stack>
    </div>
  );
};

export default RegenerateModal;
